'use client';

import { useAuthSessionObserverPublisher } from '@/lib/auth/use-auth-session-observer-publisher';
import { AuthQueryCacheSync } from './auth-query-cache-sync';

interface ProtectedAuthCacheSyncProps {
  currentUserId: string;
}

export function ProtectedAuthCacheSync({
  currentUserId,
}: ProtectedAuthCacheSyncProps) {
  useAuthSessionObserverPublisher({
    status: 'authenticated',
    currentUserId,
    source: 'protected-auth-cache-sync',
  });

  return <AuthQueryCacheSync currentUserId={currentUserId} isPending={false} />;
}
